/* Enhance the existing selector without replacing variant or cart controls. */
(()=>{
 const root=document.querySelector('#KsGearBuy-knr-043');
 if(!root)return;
 const section=root.closest('.shopify-section');
 const photos=Array.from(section.querySelectorAll('.kv-model>img'));
 root.querySelectorAll('.ks-pdp-option').forEach(button=>{
  const title=button.querySelector('strong');
  if(!title||button.querySelector('.vh-model-photo'))return;
  const label=title.textContent.trim();
  const parts=label.match(/^(Lite|Pro|Max)\s+(\([^)]*\))$/i);
  if(!parts)return;
  const photo=photos.find(image=>image.alt.toLowerCase().includes('ez-vest '+parts[1].toLowerCase()+' '));
  if(photo){
   const image=document.createElement('img');
   image.src=photo.src;image.alt='';image.width=102;image.height=72;image.className='vh-model-photo';
   button.prepend(image);
  }
  const name=document.createElement('span');name.className='vh-model-name';name.textContent=parts[1];
  const capacity=document.createElement('span');capacity.className='vh-model-capacity';capacity.textContent=parts[2];
  title.replaceChildren(name,document.createTextNode(' '),capacity);
 });
})();
